/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { ReparationConteneurDto } from '../models/reparation-conteneur-dto';


/**
 * Fonctions de gestion des réparations de conteneur
 */
@Injectable({
  providedIn: 'root',
})
export class ReparationsConteneursService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation reparationConteneurGetList
   */
  static readonly ReparationConteneurGetListPath = '/api/reparations-conteneurs/list';

  /**
   * Renvoie la liste des réparations de conteneur.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reparationConteneurGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  reparationConteneurGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ReparationConteneurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ReparationsConteneursService.ReparationConteneurGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReparationConteneurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des réparations de conteneur.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reparationConteneurGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reparationConteneurGetList(params?: {
  }): Observable<Array<ReparationConteneurDto>> {

    return this.reparationConteneurGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReparationConteneurDto>>) => r.body as Array<ReparationConteneurDto>)
    );
  }

  /**
   * Path part for operation reparationConteneurLoadList
   */
  static readonly ReparationConteneurLoadListPath = '/api/reparations-conteneurs/load-list';

  /**
   * Renvoie la liste des réparations de conteneur (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reparationConteneurLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reparationConteneurLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ReparationsConteneursService.ReparationConteneurLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des réparations de conteneur (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reparationConteneurLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reparationConteneurLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.reparationConteneurLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation reparationConteneurGet
   */
  static readonly ReparationConteneurGetPath = '/api/reparations-conteneurs/{id}';

  /**
   * Renvoie la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reparationConteneurGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  reparationConteneurGet$Response(params: {

    /**
     * Identifiant de  la réparation de conteneur
     */
    id: number;
  }): Observable<StrictHttpResponse<ReparationConteneurDto>> {

    const rb = new RequestBuilder(this.rootUrl, ReparationsConteneursService.ReparationConteneurGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReparationConteneurDto>;
      })
    );
  }

  /**
   * Renvoie la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reparationConteneurGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reparationConteneurGet(params: {

    /**
     * Identifiant de  la réparation de conteneur
     */
    id: number;
  }): Observable<ReparationConteneurDto> {

    return this.reparationConteneurGet$Response(params).pipe(
      map((r: StrictHttpResponse<ReparationConteneurDto>) => r.body as ReparationConteneurDto)
    );
  }

  /**
   * Path part for operation reparationConteneurPut
   */
  static readonly ReparationConteneurPutPath = '/api/reparations-conteneurs/{id}';

  /**
   * Met à jour la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reparationConteneurPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reparationConteneurPut$Response(params: {

    /**
     * Identifiant de la réparation de conteneur à mettre à jour
     */
    id: number;

    /**
     * Réparation de conteneur
     */
    body: ReparationConteneurDto
  }): Observable<StrictHttpResponse<ReparationConteneurDto>> {

    const rb = new RequestBuilder(this.rootUrl, ReparationsConteneursService.ReparationConteneurPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReparationConteneurDto>;
      })
    );
  }

  /**
   * Met à jour la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reparationConteneurPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reparationConteneurPut(params: {

    /**
     * Identifiant de la réparation de conteneur à mettre à jour
     */
    id: number;

    /**
     * Réparation de conteneur
     */
    body: ReparationConteneurDto
  }): Observable<ReparationConteneurDto> {

    return this.reparationConteneurPut$Response(params).pipe(
      map((r: StrictHttpResponse<ReparationConteneurDto>) => r.body as ReparationConteneurDto)
    );
  }

  /**
   * Path part for operation reparationConteneurDelete
   */
  static readonly ReparationConteneurDeletePath = '/api/reparations-conteneurs/{id}';

  /**
   * Supprime la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reparationConteneurDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reparationConteneurDelete$Response(params: {

    /**
     * Identifiant de la réparation de conteneur à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ReparationsConteneursService.ReparationConteneurDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reparationConteneurDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reparationConteneurDelete(params: {

    /**
     * Identifiant de la réparation de conteneur à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.reparationConteneurDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation reparationConteneurPost
   */
  static readonly ReparationConteneurPostPath = '/api/reparations-conteneurs';

  /**
   * Crée la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reparationConteneurPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reparationConteneurPost$Response(params: {

    /**
     * Réparation de conteneur
     */
    body: ReparationConteneurDto
  }): Observable<StrictHttpResponse<ReparationConteneurDto>> {

    const rb = new RequestBuilder(this.rootUrl, ReparationsConteneursService.ReparationConteneurPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReparationConteneurDto>;
      })
    );
  }

  /**
   * Crée la réparation de conteneur spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reparationConteneurPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reparationConteneurPost(params: {

    /**
     * Réparation de conteneur
     */
    body: ReparationConteneurDto
  }): Observable<ReparationConteneurDto> {

    return this.reparationConteneurPost$Response(params).pipe(
      map((r: StrictHttpResponse<ReparationConteneurDto>) => r.body as ReparationConteneurDto)
    );
  }

}
